import React from 'react'
import PropTypes from 'prop-types'

class ContentArea extends React.Component {
    constructor(props) {
        super(props)

        this.innerRef = React.createRef()
    }

    componentDidUpdate(prevProps) {
        if (prevProps.active !== this.props.active) {
            this.innerRef.current.scrollTo(0, 0)
        }
    }

    render() {
        const { collapsed, children } = this.props

        return (
            <div className="content-container">
                <div className="content-area">
                    <div className={`collapsible-area ${collapsed ? 'collapsed' : ''}`}>
                        <div ref={this.innerRef} className="inner-content">
                            <div>{children}</div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

ContentArea.propTypes = {
    // parent props
    active: PropTypes.string.isRequired,
    collapsed: PropTypes.bool.isRequired,
    children: PropTypes.oneOfType([PropTypes.node, PropTypes.arrayOf(PropTypes.node)])
}

ContentArea.defaultProps = {
    children: []
}

export default ContentArea
